import { Directive, ElementRef, Input, HostListener, OnInit } from '@angular/core';

@Directive({
    selector: '[numbersOnly]',
    standalone: false
})
export class NumbersOnlyDirective implements OnInit {

    @Input() numbersOnly: number;

    constructor(private el: ElementRef) {
    }

    ngOnInit() {
    }

    @HostListener('keydown', ['$event']) onKeydownHandler(e: KeyboardEvent) {
        if ([46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
            // Allow: Ctrl+C
            (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
            // Allow: Ctrl+V
            (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
            // Allow: Ctrl+X
            (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }

    }

    private checkMinMax() {
        if (this.el.nativeElement.value && parseInt(this.el.nativeElement.value) > this.numbersOnly) {
            this.el.nativeElement.value = this.numbersOnly;
        }
        if (this.el.nativeElement.value && this.el.nativeElement.value < 0) {
            this.el.nativeElement.value = 0;
        }
    }

    @HostListener('input') onEvent() {
        this.checkMinMax();
    }

}
